export const indiaVsNewzealandMyContestList = [
  {
    _id: '63cf7a0ae6b1ab001dcf8f78',
    createdOn: '2023-01-24T06:24:05.983Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce451',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'H2H',
    description: 'H2H',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 150000,
    entryFee: 100000,
    winningsPerPosition: {
      '150000': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 100,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    isBallThrown: false,
    matchId: '63cbb6ed96851a4d7f84726c',
    isCanceled: false,
    status: 1,
    statusText: 'scheduled',
    gameState: 0,
    gameStateText: 'None',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1
  }
];

export const pakVsAusMyContestList = [
  {
    _id: '624ac7f24965ce001e5d363c',
    createdOn: '2022-04-04T10:11:09.058Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'iPhone13 Gadget',
    description: 'Gadget League',
    minimumPlayers: 100000,
    maximumPlayers: 100000,
    maxTeamPerUser: 11,
    winningsAmount: 7500000,
    entryFee: 100,
    winningsPerPosition: {
      '7500000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 2500000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '62487289bc54653691c41e41',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1,
    modifiedOn: '2022-04-05T19:04:00.024Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '624c4bd6ef7a36001f872b3f',
        contestId: '624ac7f24965ce001e5d363c',
        tenant: 'dev',
        matchTeamId: '624c4bd2ef7a36001f872b3e',
        userId: '601cd58656c4dd5b565191e9',
        winning: 7500000,
        rank: 1,
        createdOn: '2022-04-05T14:01:58.440Z',
        deletedOn: null
      }
    ]
  }
];

export const pakVsNzMyContestList = [
  {
    _id: '63be89524d1c0e001debd462',
    createdOn: '2022-08-02T18:21:43.164Z',
    deletedOn: null,
    contestTypeId: '5fd31017dedfcb06b5cd21d4',
    contestCategoryId: '62e96a550056ce001fc2bdf8',
    tenant: 'gamio',
    title: 'CAT 3 Ka 3000 Mini GL',
    description: '3000 In 3',
    minimumPlayers: 1600,
    maximumPlayers: 1600,
    maxTeamPerUser: 11,
    winningsAmount: 300000,
    entryFee: 300,
    winningsPerPosition: {
      '300': 600,
      '400': 50,
      '500': 40,
      '1000': 1,
      '1500': 1,
      '2500': 1,
      '3500': 1,
      '4500': 1,
      '5000': 1,
      '7000': 1,
      '10000': 1,
      '15000': 1,
      '30000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 180000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63be86840901e17d0f43117e',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1566,
    modifiedOn: '2023-01-13T17:48:00.016Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '63c109604d1c0e001debe65b',
        contestId: '63be89524d1c0e001debd462',
        tenant: 'gamio',
        matchTeamId: '63c1095dd1aa43001dca66eb',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 892,
        createdOn: '2023-01-13T07:33:52.758Z',
        deletedOn: null
      }
    ]
  }
];

export const wiVsEngMyContestList = [
  {
    _id: '622c7576ff867e001dbb4447',
    createdOn: '2022-03-04T18:02:10.515Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'mini1',
    description: 'mini1',
    minimumPlayers: 11,
    maximumPlayers: 65,
    maxTeamPerUser: 11,
    winningsAmount: 250000,
    entryFee: 5000,
    winningsPerPosition: {
      '19000': 10,
      '20000': 1,
      '40000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '622ae1a182f394e16728d732',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 48,
    modifiedOn: '2022-03-20T22:08:00.023Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '622c82afff867e001dbb445f',
        contestId: '622c7576ff867e001dbb4447',
        tenant: 'dev',
        matchTeamId: '622c82acff867e001dbb445e',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 16,
        createdOn: '2022-03-12T11:23:27.932Z',
        deletedOn: null
      },
      {
        _id: '622c93e9ff867e001dbb4644',
        contestId: '622c7576ff867e001dbb4447',
        tenant: 'dev',
        matchTeamId: '622c855eff867e001dbb44f1',
        userId: '601cd58656c4dd5b565191e9',
        winning: 20000,
        rank: 2,
        createdOn: '2022-03-12T12:36:57.748Z',
        deletedOn: null
      }
    ]
  }
];

export const saVsEngMyContestList = [
  {
    _id: '63d0fa1967b0c2001d35fb40',
    createdOn: '2022-03-04T18:02:10.515Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'mini1',
    description: 'mini1',
    minimumPlayers: 11,
    maximumPlayers: 65,
    maxTeamPerUser: 11,
    winningsAmount: 250000,
    entryFee: 5000,
    winningsPerPosition: {
      '19000': 10,
      '20000': 1,
      '40000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    isBallThrown: false,
    matchId: '63d0d9c596851a4d7f67dcd5',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d0fbb367b0c2001d35fb4f',
        contestId: '63d0fa1967b0c2001d35fb40',
        tenant: 'dev',
        matchTeamId: '63d0fbab67b0c2001d35fb4e',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-25T09:51:47.187Z',
        deletedOn: null
      }
    ]
  }
];
export const indVsNzT20MyContestList = [
  {
    _id: '63d25c6767b0c2001d35fbde',
    createdOn: '2023-01-24T06:29:14.978Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce451',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'headtohead',
    description: 'headtohead',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 200000,
    entryFee: 150000,
    winningsPerPosition: {
      '200000': 1
    },
    selfReplicating: true,
    bonusPercentage: 10,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 100,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    isBallThrown: false,
    matchId: '63cf79bd96851a4d7f28b245',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1,
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d25d9267b0c2001d35fc07',
        contestId: '63d25c6767b0c2001d35fbde',
        tenant: 'dev',
        matchTeamId: '63d25d8267b0c2001d35fc06',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T11:01:38.841Z',
        deletedOn: null
      }
    ]
  }
];
export const indVsSlTestMyContestList = [
  {
    _id: '6225fdd264ace9001d20f92e',
    createdOn: '2022-03-07T10:22:51.861Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce452',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'Multi',
    description: 'Multi',
    minimumPlayers: 6,
    maximumPlayers: 6,
    maxTeamPerUser: 1,
    winningsAmount: 40000,
    entryFee: 10000,
    winningsPerPosition: {
      '20000': 2
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 20000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '6225783d17d940379f6d67d1',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    modifiedOn: '2022-03-14T12:32:00.022Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6229cd2c2527e9001f0ccdbb',
        contestId: '6225fdd264ace9001d20f92e',
        tenant: 'dev',
        matchTeamId: '6229cc2b2527e9001f0ccdb3',
        userId: '601cd58656c4dd5b565191e9',
        winning: 20000,
        rank: 2,
        createdOn: '2022-03-10T10:04:28.684Z',
        deletedOn: null
      }
    ]
  },
  {
    _id: '6225fdd264ace9001d20f930',
    createdOn: '2021-11-30T09:11:05.392Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61817455b2569b001f9dded3',
    tenant: 'dev',
    title: '100% Bonus',
    description: 'Bonus',
    minimumPlayers: 30,
    maximumPlayers: 30,
    maxTeamPerUser: 5,
    winningsAmount: 7000,
    entryFee: 300,
    winningsPerPosition: {
      '300': 10,
      '500': 2,
      '1000': 1,
      '2000': 1
    },
    selfReplicating: false,
    bonusPercentage: 100,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 2000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '6225783d17d940379f6d67d1',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 3,
    modifiedOn: '2022-03-14T12:32:00.022Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6229cf5d2527e9001f0ccdd2',
        contestId: '6225fdd264ace9001d20f930',
        tenant: 'dev',
        matchTeamId: '6229cc2b2527e9001f0ccdb3',
        userId: '601cd58656c4dd5b565191e9',
        winning: 500,
        rank: 3,
        createdOn: '2022-03-10T10:13:49.740Z',
        deletedOn: null
      }
    ]
  },
  {
    _id: '6225fdd264ace9001d20f910',
    createdOn: '2021-11-30T09:09:56.449Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '618284340d1e16001ef3297e',
    tenant: 'dev',
    title: 'Giveaway',
    description: 'Giveaway',
    minimumPlayers: 50,
    maximumPlayers: 50,
    maxTeamPerUser: 10,
    winningsAmount: 10000,
    entryFee: 0,
    winningsPerPosition: {
      '500': 8,
      '1000': 1,
      '2000': 1,
      '3000': 1
    },
    selfReplicating: true,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 0,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    matchId: '6225783d17d940379f6d67d1',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 3,
    modifiedOn: '2022-03-14T12:32:00.022Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6229cef72527e9001f0ccdcb',
        contestId: '6225fdd264ace9001d20f910',
        tenant: 'dev',
        matchTeamId: '6229cc2b2527e9001f0ccdb3',
        userId: '601cd58656c4dd5b565191e9',
        winning: 1000,
        rank: 3,
        createdOn: '2022-03-10T10:12:07.245Z',
        deletedOn: null
      }
    ]
  },
  {
    _id: '6225fdd264ace9001d20f926',
    createdOn: '2021-11-28T14:55:38.069Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61817f8fb2569b001f9ddedd',
    tenant: 'dev',
    title: 'Grand League',
    description: 'gl',
    minimumPlayers: 1000,
    maximumPlayers: 1000,
    maxTeamPerUser: 11,
    winningsAmount: 1000000,
    entryFee: 2000,
    winningsPerPosition: {
      '1000': 300,
      '5000': 8,
      '10000': 1,
      '20000': 1,
      '30000': 1,
      '100000': 1,
      '500000': 1
    },
    selfReplicating: false,
    bonusPercentage: 19,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 1000000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '6225783d17d940379f6d67d1',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 3,
    modifiedOn: '2022-03-14T12:32:00.022Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6229cc302527e9001f0ccdb4',
        contestId: '6225fdd264ace9001d20f926',
        tenant: 'dev',
        matchTeamId: '6229cc2b2527e9001f0ccdb3',
        userId: '601cd58656c4dd5b565191e9',
        winning: 30000,
        rank: 3,
        createdOn: '2022-03-10T10:00:16.928Z',
        deletedOn: null
      }
    ]
  }
];
export const indVsSaT20MyContestList = [
  {
    _id: '633463af29a44d001d38f039',
    createdOn: '2022-08-02T18:21:43.164Z',
    deletedOn: null,
    contestTypeId: '5fd31017dedfcb06b5cd21d4',
    contestCategoryId: '62e96a550056ce001fc2bdf8',
    tenant: 'gamio',
    title: 'CAT 3 Ka 3000 Mini GL',
    description: '3000 In 3',
    minimumPlayers: 1600,
    maximumPlayers: 1600,
    maxTeamPerUser: 11,
    winningsAmount: 300000,
    entryFee: 300,
    winningsPerPosition: {
      '300': 600,
      '400': 50,
      '500': 40,
      '1000': 1,
      '1500': 1,
      '2500': 1,
      '3500': 1,
      '4500': 1,
      '5000': 1,
      '7000': 1,
      '10000': 1,
      '15000': 1,
      '30000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 180000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63344fdc258445b807480bf7',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1600,
    modifiedOn: '2022-10-02T17:52:00.013Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6339909629a44d001d392aa4',
        contestId: '633463af29a44d001d38f039',
        tenant: 'gamio',
        matchTeamId: '63398f3069b991001fa1abdf',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 300,
        rank: 429,
        createdOn: '2022-10-02T13:22:30.991Z',
        deletedOn: null,
        modifiedOn: '2022-10-02T18:03:31.794Z',
        payment: 'processed'
      },
      {
        _id: '6339909629a44d001d392aa5',
        contestId: '633463af29a44d001d38f039',
        tenant: 'gamio',
        matchTeamId: '63398f6e29a44d001d392900',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 300,
        rank: 360,
        createdOn: '2022-10-02T13:22:30.991Z',
        deletedOn: null,
        modifiedOn: '2022-10-02T18:03:31.481Z',
        payment: 'processed'
      },
      {
        _id: '6339909629a44d001d392aa6',
        contestId: '633463af29a44d001d38f039',
        tenant: 'gamio',
        matchTeamId: '63398fa82dcd02001dbb0015',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1326,
        createdOn: '2022-10-02T13:22:30.991Z',
        deletedOn: null
      },
      {
        _id: '6339909629a44d001d392aa7',
        contestId: '633463af29a44d001d38f039',
        tenant: 'gamio',
        matchTeamId: '63398fe329a44d001d39297a',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 300,
        rank: 578,
        createdOn: '2022-10-02T13:22:30.991Z',
        deletedOn: null,
        modifiedOn: '2022-10-02T18:03:31.130Z',
        payment: 'processed'
      },
      {
        _id: '6339909629a44d001d392aa8',
        contestId: '633463af29a44d001d38f039',
        tenant: 'gamio',
        matchTeamId: '6339901c2dcd02001dbb00b2',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1238,
        createdOn: '2022-10-02T13:22:30.991Z',
        deletedOn: null
      },
      {
        _id: '6339909629a44d001d392aa9',
        contestId: '633463af29a44d001d38f039',
        tenant: 'gamio',
        matchTeamId: '6339908769b991001fa1add6',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1560,
        createdOn: '2022-10-02T13:22:30.991Z',
        deletedOn: null
      }
    ]
  },
  {
    _id: '633463af2dcd02001dbac805',
    createdOn: '2022-04-08T18:03:50.627Z',
    deletedOn: null,
    contestTypeId: '5fd31017dedfcb06b5cd21d4',
    contestCategoryId: '6182d2fcb276f100214b184d',
    tenant: 'gamio',
    title: 'CAT 2 Lakh GL',
    description: '2 Lakh GL',
    minimumPlayers: 12499,
    maximumPlayers: 12499,
    maxTeamPerUser: 11,
    winningsAmount: 20000000,
    entryFee: 3100,
    winningsPerPosition: {
      '2500': 3600,
      '3400': 790,
      '4000': 467,
      '5000': 394,
      '5500': 171,
      '6000': 93,
      '10000': 45,
      '12100': 15,
      '15000': 6,
      '18000': 4,
      '20000': 2,
      '27000': 2,
      '30000': 1,
      '40000': 2,
      '60000': 3,
      '150000': 2,
      '200000': 1,
      '400000': 1,
      '900000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 18746900,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63344fdc258445b807480bf7',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 12323,
    modifiedOn: '2022-10-02T17:52:00.013Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '6339908f29a44d001d392a88',
        contestId: '633463af2dcd02001dbac805',
        tenant: 'gamio',
        matchTeamId: '63398f3069b991001fa1abdf',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 2500,
        rank: 2470,
        createdOn: '2022-10-02T13:22:23.554Z',
        deletedOn: null,
        modifiedOn: '2022-10-02T18:04:53.364Z',
        payment: 'processed'
      },
      {
        _id: '6339908f29a44d001d392a89',
        contestId: '633463af2dcd02001dbac805',
        tenant: 'gamio',
        matchTeamId: '63398f6e29a44d001d392900',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 3400,
        rank: 1898,
        createdOn: '2022-10-02T13:22:23.554Z',
        deletedOn: null,
        modifiedOn: '2022-10-02T18:04:53.701Z',
        payment: 'processed'
      },
      {
        _id: '6339908f29a44d001d392a8a',
        contestId: '633463af2dcd02001dbac805',
        tenant: 'gamio',
        matchTeamId: '63398fa82dcd02001dbb0015',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 10322,
        createdOn: '2022-10-02T13:22:23.554Z',
        deletedOn: null
      },
      {
        _id: '6339908f29a44d001d392a8b',
        contestId: '633463af2dcd02001dbac805',
        tenant: 'gamio',
        matchTeamId: '63398fe329a44d001d39297a',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 2500,
        rank: 3650,
        createdOn: '2022-10-02T13:22:23.554Z',
        deletedOn: null,
        modifiedOn: '2022-10-02T18:04:54.015Z',
        payment: 'processed'
      },
      {
        _id: '6339908f29a44d001d392a8c',
        contestId: '633463af2dcd02001dbac805',
        tenant: 'gamio',
        matchTeamId: '6339901c2dcd02001dbb00b2',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 9691,
        createdOn: '2022-10-02T13:22:23.554Z',
        deletedOn: null
      },
      {
        _id: '6339908f29a44d001d392a8d',
        contestId: '633463af2dcd02001dbac805',
        tenant: 'gamio',
        matchTeamId: '6339908769b991001fa1add6',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 12137,
        createdOn: '2022-10-02T13:22:23.554Z',
        deletedOn: null
      }
    ]
  }
];
export const slVsAfgT20MyContestList = [
  {
    _id: '630873ab9ed304001fcf068c',
    createdOn: '2022-08-26T07:15:43.963Z',
    deletedOn: null,
    contestTypeId: '5fd31017dedfcb06b5cd21d4',
    contestCategoryId: '6182d2fcb276f100214b184d',
    tenant: 'gamio',
    title: 'CAT 60K GL',
    description: '60K Grand League',
    minimumPlayers: 4622,
    maximumPlayers: 4622,
    maxTeamPerUser: 11,
    winningsAmount: 6000000,
    entryFee: 2500,
    winningsPerPosition: {
      '2000': 1400,
      '2700': 200,
      '3800': 200,
      '4500': 20,
      '10000': 40,
      '12000': 20,
      '20000': 10,
      '24000': 5,
      '50000': 3,
      '100000': 1,
      '200000': 1,
      '400000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 5555000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '630727157e2d41535f39f628',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 4606,
    modifiedOn: '2022-08-27T17:10:00.014Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '630a216b8affc500207aedf5',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a206de37e36001f6f7045',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 2234,
        createdOn: '2022-08-27T13:51:39.926Z',
        deletedOn: null
      },
      {
        _id: '630a216b8affc500207aedf9',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a2138102dac0020fbbf7a',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 2662,
        createdOn: '2022-08-27T13:51:39.926Z',
        deletedOn: null
      },
      {
        _id: '630a216b8affc500207aedf8',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a210de37e36001f6f710e',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 2185,
        createdOn: '2022-08-27T13:51:39.926Z',
        deletedOn: null
      },
      {
        _id: '630a216b8affc500207aedfa',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a2166102dac0020fbbfb6',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 2000,
        rank: 1086,
        createdOn: '2022-08-27T13:51:39.926Z',
        deletedOn: null,
        payment: 'processed',
        modifiedOn: '2022-08-27T17:23:36.508Z'
      },
      {
        _id: '630a216b8affc500207aedf6',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a20a1102dac0020fbbeb7',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1953,
        createdOn: '2022-08-27T13:51:39.926Z',
        deletedOn: null
      },
      {
        _id: '630a216b8affc500207aedf7',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a20d9e37e36001f6f70cf',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 2000,
        rank: 1259,
        createdOn: '2022-08-27T13:51:39.926Z',
        deletedOn: null,
        payment: 'processed',
        modifiedOn: '2022-08-27T17:23:30.968Z'
      },
      {
        _id: '630a22d88affc500207af0f0',
        contestId: '630873ab9ed304001fcf068c',
        tenant: 'gamio',
        matchTeamId: '630a22ce8affc500207af0e3',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 2227,
        createdOn: '2022-08-27T13:57:44.737Z',
        deletedOn: null
      }
    ]
  },
  {
    _id: '630873abd344d0001f31021e',
    createdOn: '2022-08-02T18:21:43.164Z',
    deletedOn: null,
    contestTypeId: '5fd31017dedfcb06b5cd21d4',
    contestCategoryId: '62e96a550056ce001fc2bdf8',
    tenant: 'gamio',
    title: 'CAT 3 Ka 3000 Mini GL',
    description: '3000 In 3',
    minimumPlayers: 1600,
    maximumPlayers: 1600,
    maxTeamPerUser: 11,
    winningsAmount: 300000,
    entryFee: 300,
    winningsPerPosition: {
      '300': 600,
      '400': 50,
      '500': 40,
      '1000': 1,
      '1500': 1,
      '2500': 1,
      '3500': 1,
      '4500': 1,
      '5000': 1,
      '7000': 1,
      '10000': 1,
      '15000': 1,
      '30000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 180000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '630727157e2d41535f39f628',
    isCanceled: false,
    status: 2,
    statusText: 'Completed',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1569,
    modifiedOn: '2022-08-27T17:10:00.014Z',
    states: {
      '1': true,
      '2': true,
      '3': true
    },
    verified: true,
    winningStatus: 'COMPLETED',
    contestTeams: [
      {
        _id: '630a21728affc500207aee13',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a20d9e37e36001f6f70cf',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 300,
        rank: 491,
        createdOn: '2022-08-27T13:51:46.065Z',
        deletedOn: null,
        payment: 'processed',
        modifiedOn: '2022-08-27T17:24:12.646Z'
      },
      {
        _id: '630a21728affc500207aee11',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a206de37e36001f6f7045',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 913,
        createdOn: '2022-08-27T13:51:46.065Z',
        deletedOn: null
      },
      {
        _id: '630a21728affc500207aee15',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a2138102dac0020fbbf7a',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1058,
        createdOn: '2022-08-27T13:51:46.065Z',
        deletedOn: null
      },
      {
        _id: '630a21728affc500207aee12',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a20a1102dac0020fbbeb7',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 784,
        createdOn: '2022-08-27T13:51:46.065Z',
        deletedOn: null
      },
      {
        _id: '630a21728affc500207aee14',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a210de37e36001f6f710e',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 894,
        createdOn: '2022-08-27T13:51:46.065Z',
        deletedOn: null
      },
      {
        _id: '630a21728affc500207aee16',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a2166102dac0020fbbfb6',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 300,
        rank: 430,
        createdOn: '2022-08-27T13:51:46.065Z',
        deletedOn: null,
        payment: 'processed',
        modifiedOn: '2022-08-27T17:24:13.426Z'
      },
      {
        _id: '630a22df102dac0020fbc257',
        contestId: '630873abd344d0001f31021e',
        tenant: 'gamio',
        matchTeamId: '630a22ce8affc500207af0e3',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 907,
        createdOn: '2022-08-27T13:57:51.275Z',
        deletedOn: null
      }
    ]
  }
];
export const wiWVsIndWT20MyContestList = [
  {
    _id: '63d267cf67b0c2001d35fc14',
    createdOn: '2022-04-22T06:00:41.652Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce451',
    contestCategoryId: '61817455b2569b001f9dded3',
    tenant: 'dev',
    title: 'h2h',
    description: 'contest',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 2000,
    entryFee: 1500,
    winningsPerPosition: {
      '2000': 1
    },
    selfReplicating: true,
    bonusPercentage: 10,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 1000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    isBallThrown: false,
    matchId: '63cc017596851a4d7f92dbc2',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1,
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d2687567b0c2001d35fc25',
        contestId: '63d267cf67b0c2001d35fc14',
        tenant: 'dev',
        matchTeamId: '63d2687167b0c2001d35fc24',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T11:48:05.573Z',
        deletedOn: null
      }
    ]
  }
];
export const indVsZimMyContestList = [
  {
    _id: '63d267cf67b0c2001d35fc10',
    createdOn: '2023-01-24T06:42:59.046Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce451',
    contestCategoryId: '631301f38977f2001ed3422e',
    tenant: 'dev',
    title: 'Headtoheadtest_3',
    description: 'Headtoheadtest_3',
    minimumPlayers: 2,
    maximumPlayers: 2,
    maxTeamPerUser: 1,
    winningsAmount: 100000,
    entryFee: 70000,
    winningsPerPosition: {
      '100000': 1
    },
    selfReplicating: true,
    bonusPercentage: 10,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 200,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: true,
    isBallThrown: false,
    matchId: '63cc017596851a4d7f92dbc2',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1,
    states: {
      '1': true
    },
    verified: false
  }
];
export const engWVsAusWU19MyContestList = [
  {
    _id: '63d16d3fb5afcb001d0ad130',
    createdOn: '2021-11-03T21:25:06.006Z',
    deletedOn: null,
    contestTypeId: '5fd31017dedfcb06b5cd21d4',
    contestCategoryId: '6182d5bab276f100214b185b',
    tenant: 'gamio',
    title: 'CAT BFB 5',
    description: 'Battle Of Beginners 5',
    minimumPlayers: 12,
    maximumPlayers: 12,
    maxTeamPerUser: 3,
    winningsAmount: 5000,
    entryFee: 500,
    winningsPerPosition: {
      '1000': 5
    },
    selfReplicating: true,
    bonusPercentage: 5,
    isConfirmed: false,
    isDynamicWinnings: false,
    adminFees: 1000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    matchId: '63d166dc96851a4d7f804920',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 1,
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d28a47b5afcb001d0ad657',
        contestId: '63d16d3fb5afcb001d0ad130',
        tenant: 'gamio',
        matchTeamId: '63d28a42714ebb001dbb34ce',
        userId: '5fd32b93eaf661ea51eae8af',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T14:12:23.033Z',
        deletedOn: null
      }
    ]
  }
];
export const saWVsIndWMyContestList = [
  {
    _id: '63d294d767b0c2001d35fc4b',
    createdOn: '2022-03-21T09:56:33.446Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61821e0cb2569b001f9ddf50',
    tenant: 'dev',
    title: 'Fight of Eight',
    description: '8 teams in one contest',
    minimumPlayers: 8,
    maximumPlayers: 8,
    maxTeamPerUser: 2,
    winningsAmount: 12000,
    entryFee: 2000,
    winningsPerPosition: {
      '1000': 1,
      '2000': 1,
      '4000': 1,
      '5000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 4000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    isBallThrown: false,
    matchId: '63cbff1d96851a4d7f92725d',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d2aaf567b0c2001d35fc72',
        contestId: '63d294d767b0c2001d35fc4b',
        tenant: 'dev',
        matchTeamId: '63d2aaf067b0c2001d35fc71',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T16:31:49.786Z',
        deletedOn: null
      },
      {
        _id: '63d2ab1e67b0c2001d35fc77',
        contestId: '63d294d767b0c2001d35fc4b',
        tenant: 'dev',
        matchTeamId: '63d2ab1967b0c2001d35fc76',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T16:32:30.051Z',
        deletedOn: null
      }
    ]
  }
];
export const indWVsNzWU19MyContestList = [
  {
    _id: '63d2958167b0c2001d35fc51',
    createdOn: '2022-03-21T09:56:33.446Z',
    deletedOn: null,
    contestTypeId: '6094d1232484deb6cdcce453',
    contestCategoryId: '61821e0cb2569b001f9ddf50',
    tenant: 'dev',
    title: 'Fight of Eight',
    description: '8 teams in one contest',
    minimumPlayers: 8,
    maximumPlayers: 8,
    maxTeamPerUser: 2,
    winningsAmount: 12000,
    entryFee: 2000,
    winningsPerPosition: {
      '1000': 1,
      '2000': 1,
      '4000': 1,
      '5000': 1
    },
    selfReplicating: false,
    bonusPercentage: 0,
    isConfirmed: true,
    isDynamicWinnings: false,
    adminFees: 4000,
    requiredBucketNumber: 0,
    bucketSize: 0,
    minimumBasePayToEachWinner: 0,
    firstPositionPercentage: 15,
    percentageWinningsFromTotal: 50,
    matchDelayed: false,
    adminContest: false,
    isBallThrown: false,
    matchId: '63d1792496851a4d7f831eb1',
    isCanceled: false,
    status: 1,
    statusText: 'Scheduled',
    gameState: 0,
    gameStateText: 'Default',
    calculatedPrizeMoney: 0,
    winningsLocked: false,
    filledTeamSlots: 2,
    states: {
      '1': true
    },
    verified: false,
    contestTeams: [
      {
        _id: '63d2acce67b0c2001d35fc7c',
        contestId: '63d2958167b0c2001d35fc51',
        tenant: 'dev',
        matchTeamId: '63d2accb67b0c2001d35fc7b',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T16:39:42.748Z',
        deletedOn: null
      },
      {
        _id: '63d2ace467b0c2001d35fc81',
        contestId: '63d2958167b0c2001d35fc51',
        tenant: 'dev',
        matchTeamId: '63d2ace067b0c2001d35fc80',
        userId: '601cd58656c4dd5b565191e9',
        winning: 0,
        rank: 1,
        createdOn: '2023-01-26T16:40:04.447Z',
        deletedOn: null
      }
    ]
  }
];
